import { render, staticRenderFns } from "./AddToFolderListItem.vue?vue&type=template&id=5fb37d13"
import script from "./AddToFolderListItem.vue?vue&type=script&lang=js"
export * from "./AddToFolderListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports